const actions = {
    GET_DAILY_PLAN_REQUEST_LIST: "GET_DAILY_PLAN_REQUEST_LIST",
    GET_DAILY_PLAN_REQUEST_LIST_SUCCESSFUL: " GET_DAILY_PLAN_REQUEST_LIST_SUCCESSFUL",
    GET_DAILY_PLAN_REQUEST_LIST_FAILED: " GET_DAILY_PLAN_REQUEST_LIST_FAILED",
    PREPARE_DAILY_PLAN_REQUEST_MODAL: "PREPARE_DAILY_PLAN_REQUEST_MODAL",
    CLOSE_DAILY_PLAN_REQUEST_MODAL: "CLOSE_DAILY_PLAN_REQUEST_MODAL",
    CREATE_DAILY_PLAN_REQUEST: "CREATE_DAILY_PLAN_REQUEST",
    CREATE_DAILY_PLAN_SUCCESSFUL: "CREATE_DAILY_PLAN_SUCCESSFUL",
    CREATE_DAILY_PLAN_FAILED: "CREATE_DAILY_PLAN_FAILED",
    RESET_DAILY_PLAN: "RESET_DAILY_PLAN",
    LOCK_DAILY_PLAN: "LOCK_DAILY_PLAN",
    LOCK_DAILY_PLAN_SUCCESSFUL: "LOCK_DAILY_PLAN_SUCCESSFUL",
    LOCK_DAILY_PLAN_FAILED: "LOCK_DAILY_PLAN_FAILED",
    UNLOCK_DAILY_PLAN: "UNLOCK_DAILY_PLAN",
    UNLOCK_DAILY_PLAN_SUCCESSFUL: "UNLOCK_DAILY_PLAN_SUCCESSFUL",
    UNLOCK_DAILY_PLAN_FAILED: "UNLOCK_DAILY_PLAN_FAILED",
    PREPARE_CANCEL_MODEL: "PREPARE_CANCEL_MODEL",
    CLOSE_CANCEL_MODAL: "CLOSE_CANCEL_MODAL",
    GET_MOST_ELIGIBLE_REQUEST: "GET_MOST_ELIGIBLE_REQUEST",
    GET_MOST_ELIGIBLE_REQUEST_SUCCESSFUL: "GET_MOST_ELIGIBLE_REQUEST_SUCCESSFUL",
    GET_MOST_ELIGIBLE_REQUEST_FAILED: "GET_MOST_ELIGIBLE_REQUEST_FAILED",
    CANCEL_DAILY_PLAN: "CANCEL_DAILY_PLAN",
    CANCEL_DAILY_PLAN_SUCCESSFUL: "CANCEL_DAILY_PLAN_SUCCESSFUL",
    CANCEL_DAILY_PLAN_FAILED: "CANCEL_DAILY_PLAN_FAILED",
    RESET_COMPLETE_FORM: "RESET_COMPLETE_FORM",
    CREATE_ACTIVATION_FOR_DAILY_PLAN: "CREATE_ACTIVATION_FOR_DAILY_PLAN",
    CREATE_ACTIVATION_FOR_DAILY_PLAN_SUCCESSFUL: "CREATE_ACTIVATION_FOR_DAILY_PLAN_SUCCESSFUL",
    CREATE_ACTIVATION_FOR_DAILY_PLAN_FAILED: "CREATE_ACTIVATION_FOR_DAILY_PLAN_FAILED",
    GET_DAILY_PLAN_OTP: "GET_DAILY_PLAN_OTP",
    GET_DAILY_PLAN_OTP_SUCCESSFUL: "GET_DAILY_PLAN_OTP_SUCCESSFUL",
    GET_DAILY_PLAN_OTP_FAILED: "GET_DAILY_PLAN_OTP_FAILED",
    CHECK_DAILY_PLAN_COMPLETION_STATUS: "CHECK_DAILY_PLAN_COMPLETION_STATUS",
    CHECK_DAILY_PLAN_COMPLETION_STATUS_SUCCESSFUL: "CHECK_DAILY_PLAN_COMPLETION_STATUS_SUCCESSFUL",
    CHECK_DAILY_PLAN_COMPLETION_STATUS_FAILED: "CHECK_DAILY_PLAN_COMPLETION_STATUS_FAILED",
    COMPLETE_DAILY_PLAN_REQUEST: "COMPLETE_DAILY_PLAN_REQUEST",
    COMPLETE_DAILY_PLAN_REQUEST_SUCCESSFUL: "COMPLETE_DAILY_PLAN_REQUEST_SUCCESSFUL",
    COMPLETE_DAILY_PLAN_REQUEST_FAILED: "COMPLETE_DAILY_PLAN_REQUEST_FAILED",
    CREATE_BULK_ACTIVATION_FOR_DAILY_PLAN: "CREATE_BULK_ACTIVATION_FOR_DAILY_PLAN",
    CREATE_BULK_ACTIVATION_FOR_DAILY_PLAN_SUCCESSFUL: "CREATE_BULK_ACTIVATION_FOR_DAILY_PLAN_SUCCESSFUL",
    CREATE_BULK_ACTIVATION_FOR_DAILY_PLAN_FAILED: "CREATE_BULK_ACTIVATION_FOR_DAILY_PLAN_FAILED",
    CHECK_VALID_SERIAL_NUMBER: "CHECK_VALID_SERIAL_NUMBER",
    CHECK_VALID_SERIAL_NUMBER_SUCCESSFUL: "CHECK_VALID_SERIAL_NUMBER_SUCCESSFUL",
    CHECK_VALID_SERIAL_NUMBER_FAILED: "CHECK_VALID_SERIAL_NUMBER_FAILED",
    GET_DAILY_PLAN_ADDON: "GET_DAILY_PLAN_ADDON",
    GET_DAILY_PLAN_ADDON_SUCCESSFUL: "GET_DAILY_PLAN_ADDON_SUCCESSFUL",
    GET_DAILY_PLAN_ADDON_FAILED: "GET_DAILY_PLAN_ADDON_FAILED",

    REFUND_DAILY_PLAN_REQUEST: "REFUND_DAILY_PLAN_REQUEST",
    REFUND_DAILY_PLAN_REQUEST_SUCCESSFUL: "REFUND_DAILY_PLAN_REQUEST_SUCCESSFUL",
    REFUND_DAILY_PLAN_REQUEST_FAILED: "REFUND_DAILY_PLAN_REQUEST_FAILED",

    EXTEND_DAILY_PLAN_REQUEST: "EXTEND_DAILY_PLAN_REQUEST",
    EXTEND_DAILY_PLAN_REQUEST_SUCCESSFUL: "EXTEND_DAILY_PLAN_REQUEST_SUCCESSFUL",
    EXTEND_DAILY_PLAN_REQUEST_FAILED: "EXTEND_DAILY_PLAN_REQUEST_FAILED",

    REDUCE_DAILY_PLAN_REQUEST: "REDUCE_DAILY_PLAN_REQUEST",
    REDUCE_DAILY_PLAN_REQUEST_SUCCESSFUL: "REDUCE_DAILY_PLAN_REQUEST_SUCCESSFUL",
    REDUCE_DAILY_PLAN_REQUEST_FAILED: "REDUCE_DAILY_PLAN_REQUEST_FAILED",

    CHECK_VALID_IMEI: "CHECK_VALID_IMEI",
    CHECK_VALID_IMEI_SUCCESSFUL: "CHECK_VALID_IMEI_SUCCESSFUL",
    CHECK_VALID_IMEI_FAILED: "CHECK_VALID_IMEI_FAILED",

    GET_PENDING_DPRCOUNT_DEALER: "GET_PENDING_DPRCOUNT_DEALER",
    GET_PENDING_DPRCOUNT_DEALER_SUCCESSFUL: "GET_PENDING_DPRCOUNT_DEALER_SUCCESSFUL",
    GET_PENDING_DPRCOUNT_DEALER_FAILED: "GET_PENDING_DPRCOUNT_DEALER_FAILED",

    GET_DPR_HISTORY: "GET_DPR_HISTORY",
    GET_DPR_HISTORY_SUCCESSFUL: "GET_DPR_HISTORY_SUCCESSFUL",
    GET_DPR_HISTORY_FAILED: "GET_DPR_HISTORY_FAILED",

    getDprHistory: (id) => ({
        type: actions.GET_DPR_HISTORY,
        payload: { id }
    }),
    getDprHistorySuccessful: (result) => ({
        type: actions.GET_DPR_HISTORY_SUCCESSFUL,
        result
    }),
    getDprHistoryFailed: (error) => ({
        type: actions.GET_DPR_HISTORY_FAILED,
        error
    }),

    getPendingDprCountdealer: () => ({
        type: actions.GET_PENDING_DPRCOUNT_DEALER,
    }),
    getPendingDprCountdealerSuccess: (result) => ({
        type: actions.GET_PENDING_DPRCOUNT_DEALER_SUCCESSFUL,
        result
    }),
    getPendingDprCountdealerFailed: (error) => ({
        type: actions.GET_PENDING_DPRCOUNT_DEALER_FAILED,
        error
    }),

    extendDailyPlanRequest: (data, search) => ({
        type: actions.EXTEND_DAILY_PLAN_REQUEST,
        payload: { data, search }
    }),
    extendDailyPlanRequestSuccess: (message) => ({
        type: actions.EXTEND_DAILY_PLAN_REQUEST_SUCCESSFUL,
        payload: { message }
    }),
    extendDailyPlanRequestFailed: (error) => ({
        type: actions.EXTEND_DAILY_PLAN_REQUEST_FAILED,
        payload: { error }
    }),

    reduceDailyPlanRequest: (data, search) => ({
        type: actions.REDUCE_DAILY_PLAN_REQUEST,
        payload: { data, search }
    }),
    reduceDailyPlanRequestSuccess: (message) => ({
        type: actions.REDUCE_DAILY_PLAN_REQUEST_SUCCESSFUL,
        payload: { message }
    }),
    reduceDailyPlanRequestFailed: (error) => ({
        type: actions.REDUCE_DAILY_PLAN_REQUEST_FAILED,
        payload: { error }
    }),

    refundDailyPlanRequest: (data, search) => ({
        type: actions.REFUND_DAILY_PLAN_REQUEST,
        payload: { data, search }
    }),
    refundDailyPlanRequestSuccess: (message) => ({
        type: actions.REFUND_DAILY_PLAN_REQUEST_SUCCESSFUL,
        payload: { message }
    }),
    refundDailyPlanRequestFailed: (error) => ({
        type: actions.REFUND_DAILY_PLAN_REQUEST_FAILED,
        payload: { error }
    }),

    getDailyPlanAddon: () => ({
        type: actions.GET_DAILY_PLAN_ADDON,
    }),
    getDailyPlanAddonSuccess: (addonResult) => ({
        type: actions.GET_DAILY_PLAN_ADDON_SUCCESSFUL,
        addonResult
    }),
    getDailyPlanAddonFailed: (addonError) => ({
        type: actions.GET_DAILY_PLAN_ADDON_FAILED,
        addonError
    }),

    checkValidSerialNumber: (data) => ({
        type: actions.CHECK_VALID_SERIAL_NUMBER,
        payload: { data }
    }),
    checkValidSerialNumberSuccessful: (data) => ({
        type: actions.CHECK_VALID_SERIAL_NUMBER_SUCCESSFUL,
        payload: { data }
    }),
    checkValidSerialNumberFailed: (error) => ({
        type: actions.CHECK_VALID_SERIAL_NUMBER_FAILED,
        payload: { error }
    }),

    createBulkActivationForDailyPlan: (data, searchData) => ({
        type: actions.CREATE_BULK_ACTIVATION_FOR_DAILY_PLAN,
        payload: { data, searchData }
    }),
    createBulkActivationForDailyPlanSuccessful: (message) => ({
        type: actions.CREATE_BULK_ACTIVATION_FOR_DAILY_PLAN_SUCCESSFUL,
        payload: { message }
    }),
    createBulkActivationForDailyPlanFailed: (error) => ({
        type: actions.CREATE_BULK_ACTIVATION_FOR_DAILY_PLAN_FAILED,
        payload: { error }
    }),

    completeDailyPlanRequest: (activationID, dailyPlanID, msdn, emailID, searchData) => ({
        type: actions.COMPLETE_DAILY_PLAN_REQUEST,
        payload: { activationID, dailyPlanID, msdn, emailID, searchData }
    }),
    completeDailyPlanRequestSuccessful: (message) => ({
        type: actions.COMPLETE_DAILY_PLAN_REQUEST_SUCCESSFUL,
        payload: { message }
    }),
    completeDailyPlanRequestFailed: (error) => ({
        type: actions.COMPLETE_DAILY_PLAN_REQUEST_FAILED,
        payload: { error }
    }),

    checkDailyPlanCompletionStatus: (activationID) => ({
        type: actions.CHECK_DAILY_PLAN_COMPLETION_STATUS,
        payload: { activationID }
    }),
    checkDailyPlanCompletionStatusSuccessful: (message) => ({
        type: actions.CHECK_DAILY_PLAN_COMPLETION_STATUS_SUCCESSFUL,
        payload: { message }
    }),
    checkDailyPlanCompletionStatusFailed: (error) => ({
        type: actions.CHECK_DAILY_PLAN_COMPLETION_STATUS_FAILED,
        payload: { error }
    }),

    getDailyPlanOtp: (activationID) => ({
        type: actions.GET_DAILY_PLAN_OTP,
        payload: { activationID }
    }),
    getDailyPlanOtpSuccessful: (data) => ({
        type: actions.GET_DAILY_PLAN_OTP_SUCCESSFUL,
        payload: { data }
    }),
    getDailyPlanOtpFailed: (error) => ({
        type: actions.GET_DAILY_PLAN_OTP_FAILED,
        payload: { error }
    }),

    createActivationForDailyPlan: (data, searchData) => ({
        type: actions.CREATE_ACTIVATION_FOR_DAILY_PLAN,
        payload: { data, searchData }
    }),
    createActivationForDailyPlanSuccessful: (message) => ({
        type: actions.CREATE_ACTIVATION_FOR_DAILY_PLAN_SUCCESSFUL,
        payload: { message }
    }),
    createActivationForDailyPlanFailed: (error) => ({
        type: actions.CREATE_ACTIVATION_FOR_DAILY_PLAN_FAILED,
        payload: { error }
    }),

    resetCompleteForm: () => ({
        type: actions.RESET_COMPLETE_FORM,
    }),

    getMostEligibleRequest: (numberOfDays, addonServId) => ({
        type: actions.GET_MOST_ELIGIBLE_REQUEST,
        payload: { numberOfDays, addonServId }
    }),
    getMostEligibleRequestSuccessful: (data) => ({
        type: actions.GET_MOST_ELIGIBLE_REQUEST_SUCCESSFUL,
        payload: { data }
    }),
    getMostEligibleRequestFailed: (error) => ({
        type: actions.GET_MOST_ELIGIBLE_REQUEST_FAILED,
        payload: { error }
    }),

    getDailyPlanRequestList: (searchData) => ({
        type: actions.GET_DAILY_PLAN_REQUEST_LIST,
        payload: { searchData }
    }),
    getDailyPlanRequestSuccessful: (dailyRequestResult) => ({
        type: actions.GET_DAILY_PLAN_REQUEST_LIST_SUCCESSFUL,
        payload: { dailyRequestResult }
    }),
    getDailyPlanRequestFailed: (dailyRequestError) => ({
        type: actions.GET_DAILY_PLAN_REQUEST_LIST_FAILED,
        payload: { dailyRequestError }
    }),
    prepareDailyPlanRequestModal: () => ({
        type: actions.PREPARE_DAILY_PLAN_REQUEST_MODAL,
    }),
    closeDailyPlanRequestModal: () => ({
        type: actions.CLOSE_DAILY_PLAN_REQUEST_MODAL
    }),
    createDailyPlanRequest: (data, searchData) => ({
        type: actions.CREATE_DAILY_PLAN_REQUEST,
        payload: { data, searchData }
    }),
    createDailyPlanRequestSuccessful: (dailyRequestMessage) => ({
        type: actions.CREATE_DAILY_PLAN_SUCCESSFUL,
        payload: { dailyRequestMessage }
    }),
    createDailyPlanRequestFailed: (dailyRequestError) => ({
        type: actions.CREATE_DAILY_PLAN_FAILED,
        payload: { dailyRequestError }
    }),
    resetDailyPlan: () => ({
        type: actions.RESET_DAILY_PLAN,
    }),
    lockDailyPlanRequest: (lockData, searchData) => ({
        type: actions.LOCK_DAILY_PLAN,
        payload: { lockData, searchData }
    }),
    lockDailyPlanRequestSuccessful: (Lockmessage) => ({
        type: actions.LOCK_DAILY_PLAN_SUCCESSFUL,
        payload: { Lockmessage }
    }),
    lockDailyPlanRequestFailed: (Lockerror) => ({
        type: actions.LOCK_DAILY_PLAN_FAILED,
        payload: { Lockerror }
    }),
    unLockDailyPlanRequest: (unLockData, searchData) => ({
        type: actions.UNLOCK_DAILY_PLAN,
        payload: { unLockData, searchData }
    }),
    unLockDailyPlanSuccessful: (realselockmessage) => ({
        type: actions.UNLOCK_DAILY_PLAN_SUCCESSFUL,
        payload: { realselockmessage }
    }),
    unLockDailyPlanFailed: (realselockerror) => ({
        type: actions.UNLOCK_DAILY_PLAN_FAILED,
        payload: { realselockerror }
    }),
    prepareCancelModal: () => ({
        type: actions.PREPARE_CANCEL_MODEL
    }),
    closeCancelModal: () => ({
        type: actions.CLOSE_CANCEL_MODAL
    }),
    cancelDailyPLan: (cancelData, id, searchData) => ({
        type: actions.CANCEL_DAILY_PLAN,
        payload: { cancelData, id, searchData }
    }),
    cancelDailyPlanSuccessful: (cancelmessage) => ({
        type: actions.CANCEL_DAILY_PLAN_SUCCESSFUL,
        payload: { cancelmessage }
    }),
    cancelDailyPlanFailed: (cancelerror) => ({
        type: actions.CANCEL_DAILY_PLAN_FAILED,
        payload: { cancelerror }
    }),

    checkValidIMEI: (data) => ({
        type: actions.CHECK_VALID_IMEI,
        payload: { data }
    }),
    checkValidIMEISuccessful: (data) => ({
        type: actions.CHECK_VALID_IMEI_SUCCESSFUL,
        payload: { data }
    }),
    checkValidIMEIFailed: (error) => ({
        type: actions.CHECK_VALID_IMEI_FAILED,
        payload: { error }
    }),
};

export default actions;